import React from "react";
import { Modal, Form, Select, Input, DatePicker, Button } from "antd";
import moment from "moment";
import { postReq } from "../api";

const { TextArea } = Input;

export default function UpdateOutreachModal({
  open,
  onClose,
  outreach,
  onSuccess,
}) {
  const [form] = Form.useForm();

  if (!outreach) return null;

  const handleSubmit = async (values) => {
    const payload = {
      status: values.status,
      remark: values.remark,
      discussionNote: values.discussionNote,
      nextFollowUpAt: values.nextFollowUpAt
        ? values.nextFollowUpAt.toISOString()
        : null,
    };

    await postReq(`/common/outreach/${outreach._id}`, { ...payload });

    form.resetFields();
    onClose();
    onSuccess();
  };

  return (
    <Modal
      open={open}
      title="Update Outreach Status"
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          status: outreach.status,
        }}
      >
        {/* STATUS */}
        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: "Status is required" }]}
        >
          <Select
            placeholder="Select outcome"
            options={[
              { value: "NO_REPLY", label: "No Reply (Follow-up later)" },
              { value: "IN_DISCUSSION", label: "In Discussion" },
              { value: "REPLIED", label: "Replied" },
              { value: "NOT_INTERESTED", label: "Not Interested" },
            ]}
          />
        </Form.Item>

        {/* NEXT FOLLOW-UP (only useful for IN_DISCUSSION) */}
        <Form.Item shouldUpdate>
          {({ getFieldValue }) => {
            const status = getFieldValue("status");

            if (status !== "REPLIED") return null;

            return (
              <Form.Item
                name="nextFollowUpAt"
                label="Next Follow-up"
                rules={[
                  {
                    required: true,
                    message: "Follow-up date is required",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  disabledDate={(current) =>
                    current &&
                    current <= moment(outreach.contactedAt).endOf("day")
                  }
                />
              </Form.Item>
            );
          }}
        </Form.Item>

        {/* REMARK (ALWAYS REQUIRED) */}
        <Form.Item shouldUpdate>
          {({ getFieldValue }) => {
            const status = getFieldValue("status");

            if (status !== "REPLIED") return null;
            return (
              <Form.Item
                name="remark"
                label="Remark"
                rules={[
                  {
                    required: true,
                    message: "Remark is required to update status",
                  },
                ]}
              >
                <TextArea rows={3} placeholder="Explain outcome or next step" />
              </Form.Item>
            );
          }}
        </Form.Item>

        <Form.Item shouldUpdate>
          {({ getFieldValue }) => {
            if (getFieldValue("status") !== "IN_DISCUSSION") return null;

            return (
              <Form.Item name="discussionNote" label="Add Discussion Note">
                <TextArea
                  rows={2}
                  placeholder="Add a discussion update (optional)"
                />
              </Form.Item>
            );
          }}
        </Form.Item>

        <Button type="primary" htmlType="submit" block>
          Update Status
        </Button>
      </Form>
    </Modal>
  );
}
